import type { DominantEmotion, PlanAdherence } from 'shared';

export const planAdherenceOptions: Array<{ value: PlanAdherence; label: string }> = [
  { value: 'followed', label: 'Followed the plan' },
  { value: 'drifted', label: 'Drifted (size or stop moved)' },
  { value: 'abandoned', label: 'Abandoned (different trade)' },
];

export const emotionOptions: Array<{ value: DominantEmotion; label: string }> = [
  { value: 'conviction', label: 'Conviction' },
  { value: 'fomo', label: 'FOMO' },
  { value: 'revenge', label: 'Revenge' },
  { value: 'fear', label: 'Fear' },
  { value: 'boredom', label: 'Boredom' },
  { value: 'neutral', label: 'Neutral' },
];
